module.exports = __webpack_public_path__ + "static/img/ditie.920fec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/ditie.png
// module id = 4Nv0
// module chunks = 1